/**
 * A stored classification verdict is stale when it was not produced by the
 * classifier currently in effect (#1481).
 *
 * The comparison is EQUALITY, never ordering: `classifier_version` is a
 * date-plus-counter string ("2026-07-30.1") with no guaranteed collation, so
 * `<` is meaningless. "Not the current version" is the condition that matters
 * — which also makes an unstamped row (null/undefined/empty, i.e. anything
 * written before #1458) stale, as it should be.
 */
export function isStale(
  rowVersion: string | null | undefined,
  currentVersion: string
): boolean {
  if (!rowVersion) return true;
  return rowVersion !== currentVersion;
}

/** True when the row carries no recorded classifier version at all. */
export function isUnstamped(rowVersion: string | null | undefined): boolean {
  return !rowVersion;
}
